/**
 * Format a date string to a readable format.
 * @param {string} dateStr - ISO date string or any parseable date
 * @returns {string} Formatted date like "Jan 15, 2025"
 */
export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Calculate the number of days until a certificate expires.
 * @param {string} expiryDate - ISO date string
 * @returns {number} Days until expiry (negative if already expired)
 */
export function daysUntilExpiry(expiryDate) {
  if (!expiryDate) return -Infinity;
  const now = new Date();
  const expiry = new Date(expiryDate);
  const diffMs = expiry.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

/**
 * Get certification status based on expiry date.
 * @param {string} expiryDate - ISO date string
 * @returns {'valid'|'expiring'|'expired'} Status string
 */
export function getCertStatus(expiryDate) {
  const days = daysUntilExpiry(expiryDate);
  if (days < 0) return 'expired';
  if (days <= 90) return 'expiring';
  return 'valid';
}

/**
 * Get the display color for a certification status.
 * @param {'valid'|'expiring'|'expired'} status
 * @returns {string} Hex color code
 */
export function getCertStatusColor(status) {
  switch (status) {
    case 'valid':
      return '#6B8063';
    case 'expiring':
      return '#D4A017';
    case 'expired':
      return '#C0392B';
    default:
      return '#B2AB9C';
  }
}
